import Quill from 'quill';
import { WritingAssistantContext } from '../../../../../../types/WritingAssistant';
import { sanitize } from '../../../../../common/services/sanitizer/service';
import WritingAssistantToolbarButton from '../../../../features/WritingAssistant/WritingAssistantToolbarButton';

interface Config {
    context: WritingAssistantContext;
}

export const name = 'writingAssistant';

export function handler() {}

export const toolbarElements = [
    {
        key: 'ai',
        type: 'aiButton',
        component: ({ quill, config }: { quill: Quill; config: Config }) => {
            const getText = () => quill?.getText();
            const setText = (text: string) => {
                return quill.setContents(quill.clipboard.convert({ html: sanitize(text) }), 'user');
            };
            return <WritingAssistantToolbarButton getText={getText} setText={setText} context={config.context} />;
        },
    },
];
